import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=678927d3&scoped=true&"
import script from "./ImageView.vue?vue&type=script&lang=js&"
export * from "./ImageView.vue?vue&type=script&lang=js&"
import style0 from "./ImageView.vue?vue&type=style&index=0&id=678927d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678927d3",
  null
  
)

component.options.__file = "ImageView.vue"
export default component.exports